import { atom } from "recoil";

export const adPageAtom = atom({
  key: "adPageAtom",
  default: {
    pageNum: 1,
    status: "",
  },
});
